import defaultSettings from '@/settings'

export default {
  namespaced: true,
  state: {
    ...defaultSettings,
  },
}
